/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect, useContext } from "react";
import { ShopContext } from "../Context/ShopContext";
import axios from "axios";
import { toast } from "react-toastify";

const LoginPage = () => {
  const [currentState, setCurrentState] = useState("Login");
  const { token, setToken, navigate, backendUrl, name, setName } =
    useContext(ShopContext);

  const [password, setPassword] = useState("");
  const [email, setEmail] = useState("");

  const onSubmitHandler = async (event) => {
    event.preventDefault();

    try {
      if (currentState === "Sign Up") {
        const response = await axios.post(backendUrl + "/api/user/register", {
          name,
          email,
          password,
        });

        if (response.data.success) {
          setToken(response.data.token);
          localStorage.setItem("token", response.data.token);
          localStorage.setItem("userName", response.data.name);
          setName(localStorage.getItem("userName")); // Store name after signup
          toast.success(response.data.message);
          setCurrentState("Login");
        } else {
          toast.error(response.data.message);
        }
      } else {
        const response = await axios.post(backendUrl + "/api/user/login", {
          email,
          password,
        });

        // console.log(response.data);
        // console.log(response.data.name);

        if (response.data.success) {
          setToken(response.data.token);
          localStorage.setItem("token", response.data.token);
          localStorage.setItem("userName", response.data.name);
          setName(localStorage.getItem("userName")); // Store name after login

          toast.success(response.data.message);
        } else {
          toast.error(response.data.message);
        }
      }
    } catch (error) {
      console.log(error);
      toast.error(error.message);
    }
  };

  useEffect(() => {
    if (token) {
      navigate("/");
    }
  }, [token]);

  useEffect(() => {
    if (!token && localStorage.getItem("token")) {
      setToken(localStorage.getItem("token"));
      setName(localStorage.getItem("userName"));
    }
  }, []);

  return (
    <div className="bg-transparent w-full p-4 ">
      <div className="bg-transparent">
        <form
          onSubmit={onSubmitHandler}
          className="flex flex-col items-center w-[90%] sm:max-w-96  m-auto my-14 gap-4 text-gray-800  py-4"
        >
          <div className="inline-flex items-center gap-2 mb-2 mt-10">
            <p className="playfair-display text-3xl heading-1 lg:text-4xl text-prime-red">
              {currentState}
            </p>
            <hr className="border-none h-[1.5px] w-8 bg-zinc-500" />
          </div>
          {currentState === "Login" ? (
            ""
          ) : (
            <input
              onChange={(e) => setName(e.target.value)}
              value={name}
              type="text"
              className="w-full p-3 border border-zinc-400/50  rounded-4xl px-4 outline-prime-red"
              placeholder="Name"
              required
            />
          )}

          <input
            onChange={(e) => setEmail(e.target.value)}
            value={email}
            type="email"
            className="w-full p-3 border border-zinc-400/50  rounded-4xl px-4 outline-prime-red"
            placeholder="Email"
            required
          />
          <input
            onChange={(e) => setPassword(e.target.value)}
            value={password}
            type="password"
            className="w-full p-3 border border-zinc-400/50  rounded-4xl px-4 outline-prime-red"
            placeholder="Password"
            required
          />
          <div className="w-full flex justify-between text-sm mt-[-8px]">
            <p className="cursor-pointer underline">Forgot your password?</p>
            {currentState === "Login" ? (
              <p
                onClick={() => setCurrentState("Sign Up")}
                className="cursor-pointer underline text-blue-500"
              >
                Create Account
              </p>
            ) : (
              <p
                onClick={() => setCurrentState("Login")}
                className="cursor-pointer underline text-blue-500"
              >
                Login Here
              </p>
            )}
          </div>
          <button className="bg-black text-white font-light px-12 py-3 mt-4 rounded-full hover:border-2 hover:border-zinc-400 hover:bg-transparent hover:text-zinc-800 transition2">
            {currentState === "Login" ? "Sign In" : "Sign Up"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default LoginPage;
